/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { buildImageUrl, n } from "../utils/theme1Helpers";
import { formatNumber } from "utils/formatNumber";
export default function CartSidebarPage({
  tenantId,
  theme,
  cities,
  isMobile,
  isTablet,
  windowWidth,
  cart,
  appliedCoupon,
  couponDiscount,
  subtotal,
  shipping,
  total,
  displayCoupons,
  couponCode,
  setCouponCode,
  couponError,
  applyCouponCode,
  handleApplyCoupon,
  handleUpdateQty,
  handleRemove,
  deliveryForm,
  setDeliveryForm,
  handleCheckoutSubmit,
  isSubmitting = false,
  setShowAuthModal
}) {
  const safeBox = {
    boxSizing: "border-box",
    maxWidth: "100%",
    minWidth: 0
  };
  return (


    <div style={{
      minHeight: "100vh",
      background: theme.background,
      display: "flex",
      justifyContent: "center",
      padding: isMobile ? "10px" : "0 15px",
      ...safeBox
    }}>
      {/* ⬇⬇⬇ الصق هنا كامل Cart Sidebar الذي أرسلته نصاً بدون أي تغيير */}
      <div style={{
        width: "100%",
        maxWidth: isMobile ? "100%" : "380px",
        minWidth: 0,
        background: "white",
        borderRadius: "20px",
        padding: isMobile ? "16px" : "25px",
        boxShadow: "0 4px 30px rgba(0,0,0,0.1)",
        position: windowWidth > 992 ? "sticky" : "relative",
        top: windowWidth > 992 ? "100px" : "0",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        ...safeBox
      }}>

        {/* Cart Header - Fixed */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "25px",
          flexWrap: "wrap",
          gap: "10px",
          flexShrink: 0,
          ...safeBox
        }}>
          <h2 style={{ margin: 0, fontSize: isMobile ? "20px" : "24px", fontWeight: "700", color: "#2b1b12" }}>سلة المشتريات</h2>
          <span style={{
            background: theme.primary,
            color: "white",
            padding: "5px 12px",
            borderRadius: "15px",
            fontSize: "13px",
            fontWeight: "700",
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            ...safeBox
          }}>
            <span>
              {cart.reduce((sum, item) => sum + (item.quantity || item.qty || 0), 0)}
            </span>
            <span>منتج</span>
          </span>

        </div>

        {/* Scrollable Content Area */}
        <div className="cart-scrollable" style={{
          flex: "1",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          overflowX: "hidden",
          minHeight: 0,
          ...safeBox
        }}>

          {/* Coupon Section - تصميم جديد أنيق ووظيفي */}
          <div style={{
            background: theme.secondaryBackground,
            padding: "20px",
            borderRadius: "18px",
            marginBottom: "25px",
            border: `2px dashed ${theme.primary}44`,
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
            ...safeBox
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px", minWidth: 0, maxWidth: "100%" }}>
              <span style={{ fontSize: "26px" }}>🎟️</span>
              <h3 style={{
                margin: 0,
                fontSize: "16px",
                fontWeight: "600",
                color: "#2b1b12",
                letterSpacing: "0.3px"
              }}>
                كوبونات الخصم المتاحة
              </h3>
            </div>

            {/* حقل إدخال الكوبون */}
            <form onSubmit={handleApplyCoupon} style={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  placeholder="أدخل كود الخصم..."
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                  disabled={!!appliedCoupon}
                  style={{
                    flex: 1,
                    padding: "14px 16px",
                    border: `2px solid ${appliedCoupon ? "#ccc" : "#e0e0e0"}`,
                    borderRadius: "14px",
                    fontSize: "15px",
                    outline: "none",
                    background: appliedCoupon ? "#f8f9fa" : "white",
                    ...safeBox
                  }}
                />
                <button
                  type="submit"
                  disabled={!!appliedCoupon || !couponCode.trim()}
                  style={{
                    padding: "14px 24px",
                    background: appliedCoupon ? "#ccc" : theme.primary,
                    color: "white",
                    border: "none",
                    borderRadius: "14px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: appliedCoupon ? "not-allowed" : "pointer",
                    ...safeBox
                  }}
                >
                  تطبيق
                </button>
              </div>
              {couponError && (
                <div style={{ color: "#E74C3C", fontSize: "13px", marginTop: "8px" }}>
                  {couponError}
                </div>
              )}
            </form>

            {/* الكوبونات المتاحة - فقط الفعالة */}
            {!appliedCoupon && displayCoupons.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                {displayCoupons.map((coupon) => (
                  <div
                    key={coupon.id}
                    style={{ cursor: "pointer" }}
                    onClick={() => applyCouponCode(coupon.code)}
                  >
                    {/* التذكرة الكاملة */}

                    {isMobile ? (
                      <div style={{
                        display: "flex",
                        background: "#fffbe6",
                        borderRadius: "14px",
                        overflow: "hidden",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                        height: "90px"
                      }}>

                        {/* الجزء الأيسر */}
                        <div style={{
                          flex: 1,
                          padding: "10px 12px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "flex-end",
                          textAlign: "right"
                        }}>
                          <div style={{ fontSize: "13px", fontWeight: 700 }}>
                            {coupon.code}
                          </div>
                          <div style={{ fontSize: "11px", color: theme.primaryDark }}>
                            خصم {coupon.discountValue}{coupon.discountType === 1 ? " دينار" : "%"}
                          </div>
                        </div>

                        {/* الجزء الأيمن المصغّر */}
                        <div style={{
                          width: "60px",
                          background: theme.primary,
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "11px",
                          fontWeight: 700,
                          writingMode: "vertical-rl",
                          textOrientation: "mixed",
                          clipPath: "polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%)"
                        }}>
                          خصم
                        </div>

                      </div>
                    ) : (
                      <div style={{
                        display: "flex",
                        background: "#fffbe6",
                        borderRadius: "16px",
                        overflow: "hidden",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                        position: "relative",
                        transition: "all 0.3s ease",
                        ...safeBox
                      }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                      >
                        {/* الجزء الأيسر - الأصفر الفاتح */}
                        <div style={{
                          flex: "1",
                          padding: "24px 30px",
                          background: "#fffbe6",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "flex-end",
                          textAlign: "right",
                          position: "relative",
                          ...safeBox
                        }}>
                          {/* أيقونة نسخ */}
                          <div style={{
                            position: "absolute",
                            top: "16px",
                            left: "16px",
                            width: "30px",
                            height: "30px",
                            background: "rgba(0,0,0,0.07)",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            ...safeBox
                          }}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2">
                              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                            </svg>
                          </div>

                          {/* الكود الكبير */}
                          <div style={{
                            fontSize: "20px",
                            fontWeight: "700",
                            color: "#3a3a3a",
                            letterSpacing: "1.2px",
                            marginBottom: "6px",
                            paddingLeft: "40px",
                            ...safeBox
                          }}>

                            {coupon.code}
                          </div>

                          {/* قيمة الخصم - ديناميكي حسب الكوبون */}
                          <div style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: theme.primaryDark,
                            opacity: 0.85,
                            ...safeBox
                          }}>

                            خصم {coupon.discountValue}{coupon.discountType === 1 ? " دينار" : "%"}
                          </div>
                        </div>

                        {/* الجزء الأيمن - بلون الثيم */}
                        <div style={{
                          width: "130px",
                          background: theme.primary,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "14px",
                          fontWeight: "700",
                          letterSpacing: "1px",
                          clipPath: "polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%)",
                          writingMode: "vertical-rl",
                          textOrientation: "mixed",
                          letterSpacing: "1px",
                          flexShrink: 0,
                          ...safeBox

                        }}>
                          كوبون خصم
                        </div>

                      </div>)}

                  </div>
                ))}
              </div>
            )}

            {/* رسالة عدم وجود كوبونات */}
            {!appliedCoupon && displayCoupons.length === 0 && (
              <div style={{
                textAlign: "center",
                padding: "40px 20px",
                color: "#999",
                fontSize: "16px",
                background: "#f8f8f8",
                borderRadius: "16px",
                border: "2px dashed #ddd",
                ...safeBox
              }}>
                لا توجد كوبونات متاحة حاليًا
              </div>
            )}
          </div>

          {/* Cart Items */}
          {cart.length === 0 ? (
            <div style={{
              textAlign: "center",
              padding: "40px 20px",
              flex: "1",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <div style={{ fontSize: "64px", marginBottom: "15px" }}>🛒</div>
              <p style={{ color: "#999", margin: 0 }}>السلة فارغة </p>
            </div>
          ) : (
            <>
              <div style={{
                marginBottom: "20px",
                flexGrow: 1,
                overflowY: "auto"
              }}>

                {cart.map((item, i) => {
                  const qty = Number(item.quantity || 1);
                  const unitPrice = Number(item.price || 0); // هذا سيكون السعر الصافي الآن
                  const totalPrice = unitPrice * qty;

                  return (
                    <div
                      key={`cart-${item.variantId}-${i}`}
                      style={{
                        display: "flex",
                        gap: "15px",
                        padding: "15px",
                        background: theme.background,
                        borderRadius: "12px",
                        marginBottom: "12px",
                        ...safeBox
                      }}
                    >
                      <img
                        src={buildImageUrl(
                          item.imageUrl ||
                          item.parentImageUrl ||
                          item.mainImage ||
                          item.mainImageUrl ||
                          item.image
                        )}
                        alt={item.name || item.itemName}
                        style={{
                          width: "70px",
                          height: "70px",
                          maxWidth: "100%",
                          objectFit: "contain",
                          background: "white",
                          borderRadius: "10px",
                          padding: "6px",
                          ...safeBox
                        }}

                        onError={e => (e.target.src = "https://placehold.co/80x80.png?text=Product")}
                      />

                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                          <div>
                            <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#2b1b12" }}>
                              {item.name || item.itemName}
                            </h4>

                            {/* استبدل الجزء الخاص باللون والمقاس داخل cart.map بهذا الكود */}
                            {/* داخل حلقة الـ map في CartSidebar */}
                            {(item.color || item.size) && (
                              <div style={{ marginTop: "8px", display: "flex", alignItems: "center", gap: "10px" }}>

                                {/* عرض دائرة اللون باستخدام الحقل الموحد color */}
                                {item.color && (
                                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                    <span style={{ fontSize: "11px", color: "#888" }}>اللون:</span>
                                    <div
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "50%",
                                        backgroundColor: item.color, // سيقرأ الآن #e94444 مثلاً
                                        border: "1px solid #ddd",
                                        display: "block",
                                        flexShrink: 0
                                      }}
                                    />
                                  </div>
                                )}

                                {/* عرض المقاس */}
                                {item.size && (
                                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                    <span style={{ fontSize: "11px", color: "#888" }}>المقاس:</span>
                                    <span style={{ background: "#f0f0f0", padding: "2px 8px", borderRadius: "5px", fontSize: "12px", fontWeight: "bold" }}>
                                      {item.size}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}

                          </div>

                          <button
                            type="button"
                            onClick={() => handleRemove(item.variantId)}
                            style={{
                              background: "none",
                              border: "none",
                              color: "#999",
                              cursor: "pointer",
                              fontSize: "18px",
                              ...safeBox
                            }}
                          >
                            ×
                          </button>
                        </div>

                        <div style={{ fontSize: "16px", fontWeight: "700", color: theme.primary }}>
                          IRQ {formatNumber(Number(item.price) * Number(item.quantity))}    </div>

                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          height: "32px",
                          ...safeBox
                        }}>

                          <button
                            type="button"
                            onClick={() => qty <= 1 ? handleRemove(item.variantId) : handleUpdateQty(item.variantId, -1)}
                            style={{
                              width: "26px",
                              height: "26px",
                              border: "2px solid #E5E5E5",
                              background: "white",
                              borderRadius: "6px",
                              cursor: "pointer",
                              fontSize: "16px",
                              color: "#666",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              ...safeBox
                            }}
                          >
                            −
                          </button>

                          <div style={{
                            minWidth: "32px",
                            textAlign: "center",
                            fontSize: "14px",
                            fontWeight: "700",
                          }}>
                            {qty}
                          </div>

                          <button
                            type="button"
                            onClick={() => handleUpdateQty(item.variantId, +1)}
                            disabled={qty >= Number(item.stockQty || 999)}
                            style={{
                              width: "26px",
                              height: "26px",
                              border: (qty >= Number(item.stockQty || 999)) ? "2px solid #ccc" : `2px solid ${theme.primary}`,
                              background: (qty >= Number(item.stockQty || 999)) ? "#f5f5f5" : theme.primary,
                              borderRadius: "6px",
                              cursor: (qty >= Number(item.stockQty || 999)) ? "not-allowed" : "pointer",
                              fontSize: "16px",
                              color: (qty >= Number(item.stockQty || 999)) ? "#999" : "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              ...safeBox
                            }}
                          >
                            +
                          </button>

                        </div>
                        {qty >= Number(item.stockQty || 999) && (
                          <div style={{ fontSize: '10px', color: '#E74C3C', marginTop: '6px', textAlign: 'center', fontWeight: 'bold' }}>
                            وصلت للحد الأقصى للمخزون
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* Order Summary */}
              <div style={{
                borderTop: "2px solid #E5E5E5",
                paddingTop: "20px",
                marginTop: "20px",
                flexShrink: 0,
                ...safeBox
              }}>
                <div style={{ marginBottom: "12px", display: "flex", justifyContent: "space-between", fontSize: "14px", color: "#666" }}>
                  <span>  المجموع الفرعي</span>
                  <span>IRQ{formatNumber(subtotal)}</span>                    </div>
                {appliedCoupon && (
                  <div style={{ marginBottom: "12px", display: "flex", justifyContent: "space-between", fontSize: "14px", color: "#4CAF50" }}>
                    <span>الخصم</span>
                    <span>-IRQ{formatNumber(couponDiscount)}</span>                        </div>
                )}
                <div style={{ marginBottom: "12px", display: "flex", justifyContent: "space-between", fontSize: "14px", color: "#666" }}>
                  <span>التوصيل</span>
                  <span>{(!deliveryForm.cityId) ? "يرجى اختيار المحافظة" : (shipping === 0 ? "مجاني" : `IRQ${formatNumber(shipping)}`)}</span>
                </div>
                <div style={{
                  marginTop: "20px",
                  paddingTop: "20px",
                  borderTop: "2px solid #E5E5E5",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  ...safeBox
                }}>
                  <span style={{ fontSize: "18px", fontWeight: "700", color: "#2b1b12" }}>المجموع النهائي</span>
                  <span style={{ fontSize: "24px", fontWeight: "700", color: theme.primary }}>IRQ{formatNumber(total)}</span>
                </div>
              </div>
              {/* Checkout Form */}
              <div style={{
                marginTop: "25px",
                flexShrink: 0
              }}>
                <h3 style={{ margin: "0 0 15px 0", fontSize: "18px", fontWeight: "700", color: "#2b1b12" }}>معلومات  التوصيل </h3>
                <form noValidate onSubmit={(e) => {
                  e.preventDefault();
                  handleCheckoutSubmit(e);
                }}>


                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px", fontSize: "13px", fontWeight: "600", color: "#666" }}>الاسم</label>
                    <input
                      type="text"
                      value={deliveryForm.name}
                      onChange={(e) => setDeliveryForm({ ...deliveryForm, name: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "2px solid #E5E5E5",
                        borderRadius: "10px",
                        fontSize: "14px",
                        outline: "none",
                        ...safeBox
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px", fontSize: "13px", fontWeight: "600", color: "#666" }}>الايميل </label>
                    <input
                      type="text"
                      value={deliveryForm.email}
                      onChange={(e) => setDeliveryForm({ ...deliveryForm, email: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "2px solid #E5E5E5",
                        borderRadius: "10px",
                        fontSize: "14px",
                        outline: "none",
                        ...safeBox
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px", fontSize: "13px", fontWeight: "600", color: "#666" }}>رقم الهاتف</label>
                    <input
                      type="text"
                      value={deliveryForm.phone}
                      onChange={(e) => setDeliveryForm({ ...deliveryForm, phone: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "2px solid #E5E5E5",
                        borderRadius: "10px",
                        fontSize: "14px",
                        outline: "none",
                        ...safeBox
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px", fontSize: "13px", fontWeight: "600", color: "#666" }}>
                      المحافظة
                    </label>
                    <select
                      value={deliveryForm.cityId}
                      onChange={(e) => setDeliveryForm({ ...deliveryForm, cityId: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "2px solid #E5E5E5",
                        borderRadius: "10px",
                        fontSize: "14px",
                        outline: "none",
                        ...safeBox
                      }}
                    >

                      <option value="">اختر المحافظة</option>
                      { (cities || []).map((city, i) => (
                        <option key={`city-${city.cityId}-${i}`} value={city.cityId}>
                          {city.cityName}
                        </option>
                      ))}
                    </select>

                  </div>

                  <div style={{ marginBottom: "15px" }}>
                    <label style={{ display: "block", marginBottom: "5px", fontSize: "13px", fontWeight: "600", color: "#666" }}>العنوان </label>
                    <textarea
                      rows="3"
                      value={deliveryForm.address}
                      onChange={(e) => setDeliveryForm({ ...deliveryForm, address: e.target.value })}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "2px solid #E5E5E5",
                        borderRadius: "10px",
                        fontSize: "14px",
                        outline: "none",
                        resize: "vertical",
                        ...safeBox
                      }}
                    />
                  </div>
                  <button
                    type="button"
                    disabled={isSubmitting}
                    onClick={(e) => {
                      e.preventDefault();
                      handleCheckoutSubmit(e);
                    }}
                    style={{
                      width: "100%",
                      padding: "15px",
                      background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                      color: "white",
                      border: "none",
                      borderRadius: "12px",
                      fontSize: "16px",
                      fontWeight: "700",
                      cursor: isSubmitting ? "wait" : "pointer",
                      opacity: isSubmitting ? 0.75 : 1,
                      boxShadow: `0 4px 15px ${theme.primary}4D`,
                      transition: "all 0.3s",
                      ...safeBox
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = `0 6px 20px ${theme.primary}66`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = `0 4px 15px ${theme.primary}4D`;
                    }}
                  >
                    اطلب{isSubmitting ? "..." : ""}
                  </button>
                </form>
              </div>
            </>
          )}
        </div>
      </div>

    </div>
  );
}

